export const altCoord = (network, latitude, longitude) => new Promise(async (f, r) => {
    const res = await network.fetchData('/api/v1/altCoord/' + encodeURIComponent(latitude) + '/' + encodeURIComponent(longitude));
    if (res.ok) {
        f(await res.json());
    } else {
        r();
    }
});
export const geoSearch = (network, str) => new Promise(async (f, r) => {
    const res = await network.fetchData('/api/v1/geoSearch?q=' + encodeURIComponent(str));
    if (res.ok) {
        f(await res.json());
    } else {
        r();
    }
})
export const geocode = (network, address) => new Promise(async (f, r) => {
    const res = await network.fetchData('/api/v1/geocode?address=' + encodeURIComponent(address));
    if (res.ok) {
        f(await res.json());
    } else {
        r();
    }
});
export const reverseGeoCode = (network, latitude, longitude) => new Promise(async (f, r) => {
    const res = await network.fetchData('/api/v1/revGeocode?lat=' + encodeURIComponent(latitude) + '&lon=' + encodeURIComponent(longitude));
    if (res.ok) {
        f(await res.json());
    } else {
        r();
    }
})
export const geovalidate = (network, location) => new Promise(async (f, r) => {
    const res = await network.fetchData('/api/v1/geovalidate?q=' + encodeURIComponent(JSON.stringify(location)));
    if (res.ok) {
        f(await res.json());
    } else {
        r();
    }
})